// web/src/copilot/useRouteContextReadable.ts
//
// Slice 2 / Task F3.
//
// Publishes the user's current route (pathname + searchParams) as a
// CopilotKit readable named "route_context". The backend's per-turn
// composer (compose_per_turn_context_node) reads this on every turn
// via body.context[].
//
// Mounted once in AppShell so it follows the user across every
// authenticated route. Re-publishes automatically on navigation
// because useLocation re-renders on route change.
import { useLocation } from "react-router-dom";
import { useCopilotReadable } from "@copilotkit/react-core";

export function useRouteContextReadable(): void {
  const { pathname, search } = useLocation();
  // Drop the leading "?" so the backend sees a clean query string.
  const searchParams = search.startsWith("?") ? search.slice(1) : search;
  useCopilotReadable({
    description: "route_context",
    value: { pathname, searchParams },
  });
}
